// extracted by mini-css-extract-plugin
export default {"bg":"Bg_bg__qYzLX","white":"Bg_white__cOGvU","logo":"Bg_logo__DCVid"};